/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodsTypeEnum {
    FUTURE = 'FUTURE',
    PRESENT = 'PRESENT',
    PAST = 'PAST'
}
